import React from 'react';
export default function RainbowCapeSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="rainbow" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FF4444" />
          <stop offset="17%" stopColor="#FF8C00" />
          <stop offset="33%" stopColor="#FFD700" />
          <stop offset="50%" stopColor="#44CC44" />
          <stop offset="67%" stopColor="#4488FF" />
          <stop offset="83%" stopColor="#6644CC" />
          <stop offset="100%" stopColor="#CC44CC" />
        </linearGradient>
        <linearGradient id="rainbowShine" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="white" stopOpacity="0.3" />
          <stop offset="50%" stopColor="white" stopOpacity="0" />
          <stop offset="100%" stopColor="white" stopOpacity="0.15" />
        </linearGradient>
      </defs>

      {/* Cape shape - flowing with a cute wave */}
      <path d="M12 8 C12 8 10 10 8 30 C8 34 14 36 20 37 C26 36 32 34 32 30 C30 10 28 8 28 8 Z" fill="url(#rainbow)" />

      {/* Shine overlay */}
      <path d="M12 8 C12 8 10 10 8 30 C8 34 14 36 20 37 C26 36 32 34 32 30 C30 10 28 8 28 8 Z" fill="url(#rainbowShine)" />

      {/* Cape collar */}
      <ellipse cx="20" cy="9" rx="9" ry="3" fill="#CC3333" />
      <ellipse cx="20" cy="8.5" rx="8" ry="2" fill="#FF4444" />

      {/* Gold clasp */}
      <circle cx="20" cy="8" r="2.5" fill="#FFD700" />
      <circle cx="20" cy="8" r="1.5" fill="#FFF176" />
      <circle cx="20" cy="8" r="0.7" fill="#FFD700" />

      {/* Sparkles */}
      <circle cx="15" cy="18" r="1" fill="white" opacity="0.6">
        <animate attributeName="opacity" values="0.2;0.8;0.2" dur="1.5s" repeatCount="indefinite" />
      </circle>
      <circle cx="25" cy="24" r="0.8" fill="white" opacity="0.5">
        <animate attributeName="opacity" values="0.3;0.7;0.3" dur="2s" repeatCount="indefinite" />
      </circle>
      <circle cx="18" cy="30" r="0.6" fill="white" opacity="0.4">
        <animate attributeName="opacity" values="0.1;0.6;0.1" dur="1.8s" repeatCount="indefinite" />
      </circle>
    </svg>
  );
}
